import { render } from "./InvoicePage.vue?vue&type=template&id=59a476e3"
import script from "./InvoicePage.vue?vue&type=script&lang=js"
export * from "./InvoicePage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__